const NEARLY_FULL_PERCENTAGE = 75;
const FULL_PERCENTAGE = 100;

type Props = {
    percentage: number | null;
    // Cards stretch the bar to fill the row, so a label that changed with the value would change the bar's length.
    isCompact?: boolean;
};

const getStateClassName = (percentage: number): string => {
    if (percentage >= FULL_PERCENTAGE) {
        return 'budget-used-meter--full';
    }
    if (percentage >= NEARLY_FULL_PERCENTAGE) {
        return 'budget-used-meter--nearly-full';
    }
    return '';
};

const BudgetUsedMeter = ({ percentage, isCompact }: Props) => {
    if (percentage === null) {
        return null;
    }

    return (
        <div className={`budget-used-meter ${getStateClassName(percentage)}`}>
            <div
                className="budget-used-meter__track"
                role="progressbar"
                aria-label="Campaign budget used"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={percentage}
            >
                <span className="budget-used-meter__fill" style={{ width: `${percentage}%` }} />
            </div>
            <span className="budget-used-meter__label">{isCompact ? 'Budget used' : `${percentage}% budget used`}</span>
        </div>
    );
};

export default BudgetUsedMeter;
